export default __webpack_public_path__ + "static/media/GT-Walsheim-Bold.1bcdcd82.woff2";